import React, { useState } from "react";
import Button from "@mui/material/Button";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const FileContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[300]}`,
}));

const FileInput = ({ field, index, onChange }) => {
    const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            onChange(field.id, selectedFile);
        }
    };

    const handleRemoveFile = () => {
        setFile(null);
        onChange(field.id, null);
    };

    return (
        <>
            <Button
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
                disabled={!!file}
            >
                Upload file
                <VisuallyHiddenInput
                    type="file"
                    onChange={handleFileChange}
                />
            </Button>

            {file && (
                <FileContainer>
                    <AttachFileIcon sx={{ mr: 1 }} />
                    <Typography variant="body2" sx={{ flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {file.name} ({(file.size / 1024).toFixed(1)} KB)
                    </Typography>
                    <IconButton
                        size="small"
                        onClick={handleRemoveFile}
                        aria-label="delete file"
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </FileContainer>
            )}
        </>
    );
};

export default FileInput;